import { AiFeedbackForm as AntdAiFeedbackForm } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const AiFeedbackForm = forwardRef((props, ref) => {
  return <AntdAiFeedbackForm ref={ref} {...props} />
})

export default AiFeedbackForm
